import { urlServer } from '../mapboxgl/index.js'
export const sourceLayer = () => {
    return  [
        {
            id: 4,
            layer:'pcalordia',
            source: {
                'type': 'vector',
                "scheme": "tms",
                'tiles': [
                  ` ${urlServer}/incendios/tiles/pcalortest/{z}/{x}/{y}.pbf`
                ],
                'minzoom': 2,
                'maxzoom': 11
              }
        },
        {
            id: 22,
            layer:'anp',
            source:{
                'type': 'vector',
                "scheme": "tms",
                'tiles': [
                  `${urlServer}/incendios/tiles/anptest/{z}/{x}/{y}.pbf`
                  //'http://ec2-54-186-103-125.us-west-2.compute.amazonaws.com/map/tiles3/anp/{z}/{x}/{y}.pbf'
                ],
                'minzoom': 2,
                'maxzoom': 11
            }
        },
        {
            id: 50,
            layer:'estados',
            source: {
                'type': 'vector',
                "scheme": "tms",
                'tiles': [
                    `${urlServer}/incendios/tiles/vtiles/estados/{z}/{x}/{y}.pbf`
                ],
                'minzoom': 2,
                'maxzoom': 11
            }
        },
        {
            id: 60,
            layer:'municipios',
            source: {
                'type': 'vector',
                "scheme": "tms",
                'tiles': [
                  `${urlServer}/incendios/tiles/vtiles/municipios/{z}/{x}/{y}.pbf`
                ],
                'minzoom': 2,
                'maxzoom': 11
            }
        },
        {
            id: 88,
            layer:'aqmodis',
            source: {
                'type': 'vector',
                "scheme": "tms",
                // MVT servido por GeoServer (GWC) -> proxy /gwc_vt/<workspace>/<capa>
                'tiles': [
                  `${urlServer}/incendios/tiles/gwc_vt/aq_modis/burnday/{z}/{x}/{y}.pbf`
                ],
                'minzoom': 2,
                'maxzoom': 14
            }
        },
        {
            id: 89,
            layer:'aqmodis_outline',
            source: {
                'type': 'vector',
                "scheme": "tms",
                'tiles': [
                  `${urlServer}/incendios/tiles/gwc_vt/aq_modis/burnday/{z}/{x}/{y}.pbf`
                ],
                'minzoom': 2,
                'maxzoom': 14
            }
        },
        {
            id: 40,
            name:'P. Calor Histórico',

        },
        {
            id: 41,
            name:'Modis Histórico',

        },
        {
            id: 105,
            layer:'goes_points',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/pcalor_goes`,
              }
        },
        {
            id: 106,
            layer:'goes_heatmap_points',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/pcalor_goes_24h`,
              }
        },
        {
            id: 107,
            layer:'goes_heatmap',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/pcalor_goes_24h`,
              }
        },
        {
            id: 108,
            layer:'goes_fdcf_10min',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/pcalor_fdcf_10min`,
              }
        },
        {
            id: 109,
            layer:'goes_fdcf_heatmap_points',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/pcalor_fdcf_24h`,
              }
        },
        {
            id: 110,
            layer:'goes_fdcf_heatmap',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/pcalor_fdcf_24h`,
              }
        },
        {
            id: 120,
            layer:'rave',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/rave`,
              }
        },
        {
            id: 121,
            layer:'rave_24h',
            source: {
                'type': 'geojson',
                'data': `${urlServer}/incendios/update/rave_24h`,
              }
        }
    ]
}